import { useState } from 'react';
import { Form } from 'react-bootstrap';

type Props = {
    value: string,
    setValue: CallableFunction
}
export default function InputCurrency({ value, setValue }: Props) {
    const formatMoney = (value: string) => {
        if (!value) { return '' };
        const cleanedValue = getBalanceInt(value);

        const formattedValue = (cleanedValue / 100).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        return formattedValue;
    };

    const handleChange = (event: any) => {
        const inputValue = event.target.value;
        const cleanedValue = getBalanceInt(inputValue);

        // Only update state if the input is a number or empty
        if (!isNaN(cleanedValue) || inputValue === '') {
            setValue(formatMoney(inputValue));
        }
    };

    return (
        <Form.Control
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="R$ 0,00"
        />
    );
}

export function getBalanceInt(value: string): number {
    return Number(value.replace(/[^0-9]/g, ''));
}